import { useEffect, useRef, useState } from 'react';
import { io, Socket } from 'socket.io-client';
import { API_SOCKET_BASEURL } from '../config';
import { useAuth0 } from '@auth0/auth0-react';

export function useSocket() {
  const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
  const socketRef = useRef<Socket | null>(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || !user) return;

    let isMounted = true;

    const connectSocket = async () => {
      try {
        const token = await getAccessTokenSilently();

        if (!isMounted) return;

        const socket = io(API_SOCKET_BASEURL!, {
          transports: ['websocket'], // sin polling
          auth: { token },
          path: process.env.REACT_APP_API_SOCKET_PATH,
        });

        socketRef.current = socket;

        socket.on('connect', () => {
          console.log('✅ Conectado al WebSocket');
          setIsConnected(true);
        });

        socket.on('disconnect', () => {
          console.log('🔌 Socket desconectado');
          setIsConnected(false);
        });

        socket.on('new_notification', (data) => {
          console.log('🔔 Nueva notificación:', data);
          const audio = new Audio('/sounds/Collecting Coins 1.wav');
          audio.play();
        });
      } catch (err) {
        console.error('❌ Error al obtener el token:', err);
      }
    };

    connectSocket();

    return () => {
      isMounted = false;
      socketRef.current?.disconnect();
    };
  }, [isAuthenticated, user]);

  return {
    socket: socketRef.current,
    isConnected,
  };
}
